<template>
  <section class="section-experiences" id="experiences">
    <h2 class="section-experiences__title" style="color: white" v-reveal>{{ section.title }}</h2>

    <h3 class="section-experiences__subtitle" v-reveal>{{ section.description }}</h3>

    <SectionImage
      v-reveal
      v-for="experience in experiences"
      :key="experience.id"
      :button="{
        label: experience.external_link ? $t('knowMore') : $t('reserve'),
        link: experience.external_link || experience.booking_link,
      }"
      :reverse="experience.id % 2 === 0"
      :title="experience.title"
      :text="experience.description"
      :images="experience.images"
      @caroussel="$emit('carousel', experience.images)"
    />
    <Gallery :images="section.images" />

    <div class="section-experiences__etablissements" id="etablissements">
      <h2 class="section-experiences__title" style="color: white" v-reveal>
        {{ etablissements.title }}
      </h2>

      <h3 class="section-experiences__subtitle" v-reveal>{{ etablissements.description }}</h3>

      <div class="section-experiences__etablissements-row">
        <div
          class="section-experiences__etablissements-item"
          v-reveal="{ delay: key * 100 }"
          v-for="(i, key) in etablissements.data"
          @click="openLink(i.website)"
        >
          <img
            class="section-experiences__etablissements-item-image"
            :src="i.image.lg || i.image.original"
          />
          <Icon id="geo" class="section-experiences__etablissements-item-icon" />
          <a
            target="_blank"
            @click.stop="openLink(i.address.link)"
            class="section-experiences__etablissements-item-address"
            >{{ i.address.name }}</a
          >
          <a
            :href="i.website"
            target="_blank"
            class="navbar__external section-experiences__etablissements-item-reservation"
            >{{ $t('visitWebsite') }}
            <Icon id="oblique-arrow" />
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Gallery from './Gallery.vue'
import SectionImage from './SectionImage.vue'

export default {
  name: 'SectionExperiences',
  components: { SectionImage, Gallery },
  props: {
    section: {
      type: Object,
      required: true,
    },
    etablissements: {
      type: Object,
      required: true,
    },
  },
  computed: {
    experiences() {
      return Object.values(this.$beet.experiences).toSorted((a, b) => {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
      })
    },
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    },
  },
}
</script>
